module.exports = __webpack_public_path__ + "static/media/bw.d21a2b61.svg";